import { observer } from 'mobx-react-lite'
import cn from 'classnames'

import { useApp } from 'utils'

import { Tooltip, TooltipProps } from '../UI/Tooltip/Tooltip'

import './styles.scss'

interface Props extends TooltipProps {
  step: number
}

export const StepTooltip = observer(({ step, content, className, ...rest }: Props) => {
  const { currentOnboardingStep, totalOnboardingSteps, setNextOnboardingStep, closeOnboarding } =
    useApp()

  const isShown = step === currentOnboardingStep

  const tooltipJsx = (
    <>
      {content}
      {currentOnboardingStep && totalOnboardingSteps && (
        <div className="tooltip-footer">
          <div>
            {currentOnboardingStep} <span className="total">/ {totalOnboardingSteps}</span>
          </div>
          <button className="next-btn" onClick={setNextOnboardingStep}>
            {currentOnboardingStep === totalOnboardingSteps ? 'Готово' : 'Далее'}
          </button>
        </div>
      )}
    </>
  )

  return (
    isShown && (
      <Tooltip
        {...rest}
        className={cn('step-tooltip', className)}
        rounded={false}
        onClose={closeOnboarding}
        content={tooltipJsx}
      />
    )
  )
})
